import { useGetAccountsQuery } from "@/modules/account/services";
import type { IBudgetTransferTemplateForm } from "@/modules/template/common/types";
import { BudgetTransferTemplateForm } from "@/modules/template/components";
import {
  budgetTransferTemplateValidationSchema
} from "@/modules/template/validations/validationSchema";
import { ResidenceType } from "@/modules/transaction/common/enum";
import { INITIAL_PAGE_SIZE } from "@/shared/common/constants";
import { Currencies, Storage } from "@/shared/common/enums";
import type { IOperationPageProps } from "@/shared/common/types";
import { PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { useState } from "react";

export const BudgetTransferTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();
  const [isTinValid, setIsTinValid] = useState<boolean>(true);
  const [isAccountNumberInvalid, setIsAccountNumberInvalid] = useState<boolean>(false);
  const { data: accountsList = [] } = useGetAccountsQuery({
    pageSize: INITIAL_PAGE_SIZE,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const initialValues: IBudgetTransferTemplateForm = {
    creditBudgetAccount: "",
    debitAccount: "",
    amount: "",
    tin: localStorage.getItem(Storage.Tin) || "",
    purpose: "",
    commissionAccount: "",
    isAuthorizedTransfer: false,
    currency: Currencies.AMD,
    authorizedBudgetTransferParty: {
      fullName: "",
      residency: ResidenceType.Resident,
      partyType: "",
      tin: "",
      ssn: "",
      documentType: "",
      documentNumber: "",
      address: "",
      authorizedPerson: "",
      additionalInfo: "",
    },
    regionCode: "",
    messages: {
      reportCode: "",
      message1: "",
      message2: "",
      message3: "",
      message4: "",
      message5: "",
      message6: "",
    }
  };

  return (
    <FormContainer
      className="full-width page-container form-layout"
      formId="form-container"
      mode="onBlur"
      reValidateMode="onBlur"
      initialValues={initialValues}
      validationScheme={budgetTransferTemplateValidationSchema({
        t,
        isTinValid,
        isAccountNumberInvalid,
      })}
    >
      <PageHeader/>
      <BudgetTransferTemplateForm
        isEdit={isEdit}
        accountsList={accountsList}
        setIsTinValid={setIsTinValid}
        setIsAccountNumberInvalid={setIsAccountNumberInvalid}
      />
    </FormContainer>
  );
};
